import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { FACEBOOK_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const FacebookIcon = (props: IconGlyphProps) => <Icon {...props} glyph={FACEBOOK_GLYPH} />;
